/*global FB*/
import React from 'react'
import css from './style.scss'
import {FullPage} from 'components/container';
import PageChooser from './page_chooser';
import Loading from 'components/shared/loading'
import api from './api'
import store from 'utils/store'
import {push} from 'react-router-redux'
import {Redirect} from 'react-router'
import {connect} from 'react-redux';
import FBComponent from 'components/shared/facebook/fb_component';
import PermissionsPopup from 'components/shared/facebook/permissions';
import { normalize, schema } from 'normalizr';
import permissions from 'shared/permissions'
import FacebookConnect from './facebook_connect'

class SetupAccountPage extends FBComponent{
  constructor(props){
    super(props)
    this.state={
      fb_user_logged:false,
      accounts:[],
      fb_permissions_error:false,
      missing_fb:false
    }
  }
  checkLoginState (response) {
    if (response.authResponse) {
      if(response.authResponse.userID===this.props.facebook){
        window.FB.api("me/permissions",(perms)=>{
          console.log("perms", perms)
          if(perms.data.some(p=>p.status!=="granted")){
            this.setState({fb_permissions_error:true})
          }else{
            //here you have the USER access token. if we send this to the server and extend it before asking for /me/accounts, we are ok.
            api.getFacebookAccounts(response.authResponse.accessToken, response.authResponse.userID).then(accounts=>{
              this.setState({fb_user_logged:true, accounts})
            })
          }
        })
      }else{
        this.setState({missing_fb:true, missing_fb_message: "USER_MISMATCH"})
      }
    }
  }
  FBIsReady=()=>{
    this.setState({fb_permissions_error:false, missing_fb:false})
    if(this.props.facebook){
      window.FB.getLoginStatus((response) => {
        if (response.status !== 'connected') {
          FB.login(this.checkLoginState.bind(this), { scope: process.env.REACT_APP_FB_SCOPES });
        } else {
          this.checkLoginState(response);
        }
      });
    }else{
      this.setState({missing_fb:true})
    }
  }
  handleLogin(response){
    this.setState({fb_user:response});
  }
  handleChooseAccount(data){
    api.createAccount(data).then((data)=>{
      if(data){
        if(data.err){
          
        }else{
          const account = new schema.Entity('accounts');
          const normalizedData = normalize(data, account);
          store.dispatch({type:"ADD_ACCOUNT", payload:normalizedData.accounts})
          store.dispatch(push("/"));
        }
      }
      
    })
  }
  render(){
    if(permissions.createAccount(this.props.subscription,this.props.activeAccounts)){
      return (
        <FullPage withContainer containerClass={css.setupAccountPage}>
          {!this.state.missing_fb && <h3>Add a new Account</h3>}
          {this.state.fb_permissions_error &&
            <PermissionsPopup
              onEveryThingIsBackToNormal={this.FBIsReady}
            />
          }
          {this.state.missing_fb && <FacebookConnect message={this.state.missing_fb_message} onConnected={this.FBIsReady}/>}
          {!this.state.fb_user_logged && !this.state.missing_fb && <Loading/>}
          {this.state.fb_user_logged && <PageChooser accounts={this.state.accounts} onChoose={this.handleChooseAccount.bind(this)}/>}
        </FullPage>
      )
    }else{
      return (
        <Redirect to="/"/>
      )
    }
  }
}


const mapStateToProps=(state)=>{
  return {
    facebook:state.user.userData.facebook,
    pro:state.user.userData.subscription.active,
    subscription:state.user.userData.subscription,
    activeAccounts:Object.keys(state.accounts).map(a=>state.accounts[a]).filter(a=>a.paused_at===undefined).length
  }
}

export default connect(mapStateToProps)(SetupAccountPage)



// WEBPACK FOOTER //
// ./src/components/setup/index.js